import { slugify } from './slugify'

const CACHE_KEY = 'product_slug_cache'

type SlugCache = Record<string, string>

function readCache(): SlugCache {
  try {
    const raw = localStorage.getItem(CACHE_KEY)
    return raw ? (JSON.parse(raw) as SlugCache) : {}
  } catch {
    return {}
  }
}

function writeCache(cache: SlugCache): void {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(cache))
  } catch {
    // localStorage may be unavailable (e.g. private browsing quota exceeded)
  }
}

export function setSlugMapping(slug: string, productId: string): void {
  const cache = readCache()
  cache[slug] = productId
  writeCache(cache)
}

export function getProductIdBySlug(slug: string): string | undefined {
  return readCache()[slug]
}

export function cacheProductSlugs(
  products: Array<{ id: string; title: string }>,
): void {
  const cache = readCache()
  for (const product of products) {
    const slug = slugify(product.title)
    if (slug) {
      cache[slug] = product.id
    }
  }
  writeCache(cache)
}
